export const CURRENT_CHAIN_ID = 'current_chain_id';

export const SLIPPAGE_TOLERANCE = 'slippage_tolerance';

export const VAULTS_VIEW = 'viewMode';

export const HIDE_CREATED_VAULT_MODAL = 'hide_created_vault_modal';

export const VIEW_ADDRESS = 'view_address';

export const VAULTS_FILTERS = 'vaults_filters';
